import { defineAction } from '~/prix'
import residenceUpdateAction from './residenceUpdate.action.json' with { type: 'json' }
import { residenceObject } from '../residenceObject'
import { z } from 'zod'

const residenceUpdateDefinition = defineAction({
  ...residenceUpdateAction,

  input: residenceObject
    .omit({
      code: true,
      residents: true,
      images: true,
      ruralProperty: true,
    }),
  output: z.object({ residenceCustomCode: z.string().nullish() }),
})

export default residenceUpdateDefinition
